import React from 'react';
import MealPage from './MealPage';
import { colors } from '../theme';
import { MEAL_LABELS } from '../constants/mealLabels';

const BreakfastPage = () => (
  <MealPage mealtime="breakfast" title={MEAL_LABELS.breakfast} accentColor={colors.meal.breakfast} />
);

export default BreakfastPage;
